// Сравнение до трёх авиабилетов
import type { Currency, Ticket } from '@sayohat/shared';
import { createStore, useStore } from '../../shared/lib/store';
import type { SavedQuery } from '../../shared/lib/types';
import { toast } from '../../shared/ui/Toast';

export const MAX_COMPARE = 3;

export interface CompareItem {
  t: Ticket;
  currency: Currency;
  query: SavedQuery;
}

export const compareStore = createStore({ items: [] as CompareItem[], open: false });

export const useCompare = () => useStore(compareStore);
export const useIsCompared = (id: string): boolean => useStore(compareStore, (s) => s.items.some((x) => x.t.id === id));

const has = (id: string) => compareStore.get().items.some((x) => x.t.id === id);

/** Добавить/убрать билет; возвращает, выбран ли он теперь */
export function toggleCompare(t: Ticket, ctx: { currency: Currency; query?: SavedQuery }): boolean {
  let items = compareStore.get().items;
  if (has(t.id)) {
    items = items.filter((x) => x.t.id !== t.id);
  } else {
    if (items.length >= MAX_COMPARE) { toast(`Сравнить можно до ${MAX_COMPARE} билетов`); return false; }
    if (items.length && items[0].currency !== ctx.currency) items = [];
    items = [...items, { t, currency: ctx.currency, query: ctx.query || {} }];
  }
  compareStore.set({ items });
  return has(t.id);
}

export function removeCompare(id: string): void {
  const items = compareStore.get().items.filter((x) => x.t.id !== id);
  compareStore.set({ items, open: compareStore.get().open && items.length >= 2 });
}

export const clearCompare = (): void => compareStore.set({ items: [], open: false });
export const openCompare = (): void => { if (compareStore.get().items.length >= 2) compareStore.set({ open: true }); };
export const closeCompare = (): void => compareStore.set({ open: false });
